import Container from '@mui/material/Container'
import { Auth } from 'aws-amplify'
import { ConfirmProvider } from 'material-ui-confirm'
import { closeSnackbar, enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'

import Page from 'components/elements/Page'
import Loading from 'components/Loading'
import Section from 'components/Section'
import SnackbarComponent from 'components/SnackbarComponent'
import listParticipantsByEventAndEmail from 'hooks/listParticipantsByEventAndEmail'
import { Event, Participant, Toast } from 'models/API'

import Results from './results'
import Search from './search'
import searchSchema from './search/form/schema'

const Participants = () => {
  // ?? Email update to new/current participant
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [event, setEvent] = useState<Event>()
  const [participants, setParticipants] = useState<Participant[]>([])

  const [loggedInUser, setLoggedInUser] = useState()

  const toast = ({ title, message, variant = 'success' }: Toast) => {
    enqueueSnackbar(<SnackbarComponent title={title} message={message} />, {
      variant,
      anchorOrigin: { horizontal: 'center', vertical: 'top' },
      autoHideDuration: 10000,
      onClose: (event, reason, key) => {
        if (reason === 'instructed') {
          closeSnackbar(key)
        }
      },
    })
  }

  useEffect(() => {
    let didCancel = false
    if (didCancel) return

    const getData = async () => {
      try {
        const { attributes } = await Auth.currentAuthenticatedUser({
          bypassCache: true,
        })
        setLoggedInUser(attributes)
      } catch (e) {
        navigate('/login', { replace: true })
      }
    }

    getData()
    return () => {
      didCancel = true
    }
  }, [navigate, setLoggedInUser])

  const handleSearch = async (
    event: Event,
    values: Yup.InferType<typeof searchSchema>,
  ) => {
    setLoading(true)
    setEvent(event)

    const results = await listParticipantsByEventAndEmail({
      eventId: values.eventId,
      email: values.email,
    })

    setParticipants(results.participants)
    setLoading(false)
  }

  if (!loggedInUser) <Loading loading={loading} desc="One moment..." />

  return (
    <Section>
      <Page noPadding>
        <Container>
          <Search onSubmit={handleSearch} />
          <ConfirmProvider>
            <Results
              loading={loading}
              event={event}
              participants={participants}
              loggedInUser={loggedInUser}
              toast={toast}
            />
          </ConfirmProvider>
        </Container>
      </Page>
    </Section>
  )
}
export default Participants
